import { Component,ChangeDetectorRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { FormHelperService } from '../../../services/form-helper.service';
import { categories, currencies, distributionChannels, dummyAcknowledgements, AccountTypes } from './ref-data';
import { MerchantRegistrationService } from '../../../services/merchant-registration-service';
import { PostMerchantFormRequest } from '../../../shared/PostMerchantRequestForm';
import notify from 'devextreme/ui/notify';
import { merchantService } from '../../../components/utils/models/MerchantService';
import { Country } from '../../../components/utils/models/country';
import { MerchantCategory } from '../../../components/utils/merchantcategory';
import { KeycloakService } from 'keycloak-angular';
import { CompanyDetailsComponent } from '../company-details/company-details.component';
import { registrationNumberValidator } from '../../../components/utils/validators/registrationNumberValidator';
import { exactLengthValidator } from '../../../components/utils/validators/exactLengthValidator';
import { UtilityFunctions } from '../../../shared/helpers/utility-functions';
import { ContactDetailsComponent } from '../contact-details/contact-details.component';
import { AddressComponent } from '../address/address.component';
import { DirectDebitInstructionsComponent } from '../direct-debit-instructions/direct-debit-instructions.component';
import { RegisterMerchantServicesComponent } from '../register-merchant-services/register-merchant-services.component';

@Component({
  selector: 'app-register-merchant-form-container',
  templateUrl: './register-merchant-form-container.component.html',
  styleUrl: './register-merchant-form-container.component.scss'
})
export class RegisterMerchantFormContainerComponent {
  currentYear = new Date(Date.now()).getFullYear();

  // only whole numbers without decimal places
  wholeNumbers = '^[0-9]*$';
  phoenixIdFormatRegex = /^[A-Fa-f0-9]{8}[A-Fa-f0-9]{4[A-Fa-f0-9]{4}[A-Fa-f0-9]{4}[A-Fa-f0-9]{12}$/;

  // decimals with optional 2 decimal digits that are separated by dot
  numTwoDecimalDigits = '^\\d+\\.?\\d{0,2}$';

  isSubmitBtnDisabled = false;
  newFormData!: Record<string, any>;
  isContentScrolled = false;
  isDataChanged = false;
  oldFormData!: Record<string, any>;
  submitFormResult = '';
  @Output() notifyMerchantCreated = new EventEmitter<any>();
  registrationForm! : FormGroup;
  retrievedKeycloakId! : string;
  addressEventCounter = 0;
  debitInstructionsEventCounter = 0;
  servicesCounter = 0;
  // red : string = "red";


  // ideally this should come from the backend
  allCategories = categories;
  allCurrencies = currencies;
  allEntityTypes! : Array<string>;
  allDistributionChannels = distributionChannels;
  allAcknowledgements = dummyAcknowledgements;
  AllAccountTypes = AccountTypes;
  DBMerchantId : number = 0;
  DBAddressId : number = 0;
  
  @ViewChild('companysubComponent') companyDetailsComponent!: CompanyDetailsComponent;
  @ViewChild('contactssubComponent') contactDetailsComponent!: ContactDetailsComponent;
  @ViewChild('addresssubComponent') addressDetailsComponent!: AddressComponent;
  @ViewChild('directdebitinssubComponent') debitDetailsComponent!: DirectDebitInstructionsComponent;
  @ViewChild('servicesubComponent') serviceDetailsComponent!: RegisterMerchantServicesComponent;
  
  constructor(
    private fb: FormBuilder, 
    private _formHelperService: FormHelperService,
    private _apiService : MerchantRegistrationService,
    private cdr: ChangeDetectorRef,
    private _keycloakService : KeycloakService) 
    {
      
      this._keycloakService
          .loadUserProfile()
          .then(e => {
            this.retrievedKeycloakId = e.id!;
          });

          this.registrationForm = this.fb.group({
            companyDetails: this.fb.group({
              entitytype: ['', Validators.required],
              companyName: ['', Validators.required],
              registrationNumber: ['', [Validators.required]],
              saccraMemberNumber: ['',],
              ncrRegistrationNumber: ['', [Validators.required]],
              phoenixId: ['',[this.phoenixIdValidator]]
            }),
            contactDetails: this.fb.group({
              contactName: ['', Validators.required],
              contactSurname: ['', Validators.required],
              contactPhoneNumber: ['', [Validators.required,Validators.minLength(10)]], // don't remove, requires async validator
              contactEmail: ['', [Validators.required, Validators.email]],
            }),
            addressDetails: this.fb.group({
              unitNumberAndComplex : [''],
              numberAndStreetname : ['',Validators.required],
              suburb : ['',Validators.required],
              city : ['', Validators.required],
              code : ['',Validators.required],
              country : ['',Validators.required]
            }),
            directDebitDetails: this.fb.group({
              account : ['',[Validators.required, Validators.pattern(this.wholeNumbers)]],
              bankname : ['', Validators.required],
              branchcode : ['',Validators.required],
            }),
            services: this.fb.group({
              ServicesSelected: [[], Validators.required],
              Wallets: ['', Validators.required], 
            },{ validators: this.customValidator })
          });
    }

  hasStepError(stepName: string): boolean {
    
    const step = this.registrationForm.get(stepName);
    return (step && step.invalid && (step?.touched || step?.dirty)) ?? true;
  }

  get formHelperService() {
    return this._formHelperService;
  }

  get companyDetailsForm() {
    return this.registrationForm.get('companyDetails') as FormGroup;
  }

  get addressDetailsForm() {
    return this.registrationForm.get('addressDetails') as FormGroup;
  }

  get directDebitDetailsForm() {
    return this.registrationForm.get('directDebitDetails') as FormGroup;
  }

  get contactDetailsForm() {
    return this.registrationForm.get('contactDetails') as FormGroup;
  }

  get servicesForm() {
    return this.registrationForm.get('services') as FormGroup;
  }
  
  
  private populateAttributes()
  {

    let merchantServices : Array<merchantService>  = this.addServiceControls(this.servicesForm , ["Wallets"]);
    let merchantcategory : MerchantCategory = {
      id: 0,
      name : this.companyDetailsForm.get('entitytype')?.value
    }

    let _merchantFormRequest = new PostMerchantFormRequest({ 
      //company Details : when we split these will go together
      entitytype: merchantcategory.name,
      MerchantId : this.DBMerchantId,
      KeycloakUserId : this.retrievedKeycloakId,
      companyName: this.companyDetailsForm.get('companyName')?.value,
      registrationNumber: this.companyDetailsForm.get('registrationNumber')?.value,
      sacraNumber: this.companyDetailsForm.get('saccraMemberNumber')?.value,
      NCRRegistrationNumber : this.companyDetailsForm.get('ncrRegistrationNumber')?.value,
      merchantCategory : merchantcategory.name,
      phoenixId : this.companyDetailsForm.get('phoenixId')?.value,
      //contact Details : when we split these will go together
      contactName : this.contactDetailsForm.get('contactName')?.value,
      contactMiddleName : this.contactDetailsForm.get('contactMiddleName')?.value,
      contactSurname : this.contactDetailsForm.get('contactSurname')?.value,
      contactPhoneNumber : this.contactDetailsForm.get('contactPhoneNumber')?.value,
      contactEmail : this.contactDetailsForm.get('contactEmail')?.value,
      //Address Details
      address : 
      {
        id: this.DBAddressId,
        merchantId: this.DBMerchantId,
        unitNumberAndComplex : this.addressDetailsForm.get('unitNumberAndComplex')?.value,
        numberAndStreet : this.addressDetailsForm.get('numberAndStreetname')?.value,
        suburb : this.addressDetailsForm.get('suburb')?.value, 
        city : this.addressDetailsForm.get('city')?.value,  
        code : this.addressDetailsForm.get('code')?.value, 
        country :  this.addressDetailsForm.get('country')?.value
      },
      accountNumber : this.directDebitDetailsForm.get('account')?.value,
      bankname : this.directDebitDetailsForm.get('bankname')?.value,
      bankcode : this.directDebitDetailsForm.get('bankcode')?.value,
      branchcode : this.directDebitDetailsForm.get('branchcode')?.value,
      walletNumber : this.servicesForm.get('Wallets')?.value,
      merchantServices : merchantServices
    });
     
    return _merchantFormRequest;
  }

  submitForm(isFinalSubmit, event) {

    const button = event.component;
    button.option('disabled', true);

    const merchantForm = this.populateAttributes();
    this.submitFormResult = JSON.stringify(merchantForm);
    
    this.companyDetailsComponent.merchantCreateUpdate({ showLoadPanel : true, message : "Merchant Save in progress." });

    this
    ._apiService
    .SubmitMerchantForm(merchantForm)
    .subscribe(res =>
    {
        
        this.DBMerchantId = res['merchantId'];
        this.DBAddressId = res['addressId'];
        
        if(isFinalSubmit){

          this.notifyMerchantCreated.emit(true);
          UtilityFunctions.showMessage(`New merchant account has been successfully registered.`, "success", 4000);
        }else{

          notify({message: 'Data saved', position: {at: 'top right', my: 'top right',direction: "up-push"}}, 'success');
        }
       this.companyDetailsComponent.merchantCreateUpdate({ showLoadPanel : false, message : "Merchant Saved" });

      },
      error => {

        console.error("Error Occured",error);
        button.option('disabled', false);
        this.companyDetailsComponent.merchantCreateUpdate({ showLoadPanel : false, message : "Merchant Error" });
      }
    );
  }

  save() {
    notify({message: 'Data saved', position: {at: 'top right', my: 'top right',direction: "up-push"}}, 'success');
    this.isDataChanged = false;
    this.setSavedData();
  }

  setSavedData(data = this.oldFormData)
  {
    
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }
  
  cancel(CancellingComponent : string = '') {
    this.newFormData = this.oldFormData;

    this.companyDetailsComponent.cancel();
    this.contactDetailsComponent.cancel();
    this.addressDetailsComponent.cancel();
    this.debitDetailsComponent.cancel();
    this.serviceDetailsComponent.cancel();

    this.registrationForm.get('addressDetails')?.markAsPristine();
    this.registrationForm.get('companyDetails')?.markAsPristine();
    this.registrationForm.get('contactDetails')?.markAsPristine();
    this.registrationForm.get('directDebitDetails')?.markAsPristine();
    this.registrationForm.get('services')?.markAsPristine();

    setTimeout(() => {
      this.isDataChanged = false;
    });
  }

  dataChanged(event) {

    // view populated form
    if('FormType' in event)
    {
      if(event['FormType'] == 'Address'){

        // this is intended to skip marking the form as dirty when the default values are updating the form
        this.addressEventCounter++;
        if (this.addressEventCounter <= 1) {
          return;
        }
        this.registrationForm.get('addressDetails')?.markAsDirty();
      
      }else if(event['FormType'] == 'CompanyDetails'){
        
        this.registrationForm.get('companyDetails')?.markAsDirty();
      }
      else if(event['FormType'] == 'ContactDetails' ){

        this.registrationForm.get('contactDetails')?.markAsDirty();

      }else if(event['FormType'] == 'DebitInstructions'){

        // this is intended to skip marking the form as dirty when the default values are updating the form
        this.debitInstructionsEventCounter++;
        if (this.debitInstructionsEventCounter <= 3) {
          return;
        }
        
        this.registrationForm.get('directDebitDetails')?.markAsDirty();
      
      }else if(event['FormType'] == 'Services'){

        // this is intended to skip marking the form as dirty when the default values are updating the form
        this.servicesCounter++;
        if (this.servicesCounter <= 1) { 
          return;
        }
        this.registrationForm.get('services')?.markAsDirty();
      }
    }
    
    this.isDataChanged = true;
    // please don't remove, error was caused by the default values in address section, when form was being initialized
    this.cdr.detectChanges();  
  }

  public addServiceControls(servicesFormGroup: FormGroup | FormArray, keysToLeaveOut: Array<string> ): Array<merchantService>
  {
    
    let objectsToReturn: Array<merchantService> = [];
    servicesFormGroup.get('ServicesSelected')?.value
      .forEach((selectedServiceName: string) => {

        
          let merchantService: merchantService = {
            merchantId: 0,
            serviceId: 0,
            Active: true,
            service: {
              id: 0,
              domainEvents: [{}],
              created: new Date(),
              createdBy: '',
              lastModified: new Date(),
              lastModifiedBy: '',
              name: selectedServiceName,
              description: selectedServiceName,
              active: true
            }
          }

          objectsToReturn.push(merchantService);
        
    });

    return objectsToReturn;
  }

  get isCompanyFormValid() {

    const phoenixIdControl = this.registrationForm.get('companyDetails')?.get('phoenixId');
    if (phoenixIdControl) {
      phoenixIdControl.updateValueAndValidity();
    }

    return this.registrationForm.get('companyDetails')!.valid 
    && this.registrationForm.get('contactDetails')!.valid
    && this.registrationForm.get('addressDetails')!.valid
    && this.registrationForm.get('directDebitDetails')!.valid
    && this.registrationForm.get('services')!.valid

  }

  customValidator(group: FormGroup): ValidationErrors | null {

    const walletsControl = group.get('Wallets');
    const ServicesControl = group.get('ServicesSelected');
    
    const isAtLeastOneFieldTrue = ServicesControl?.value.length > 0;
    const isWalletsPopulated =  (typeof walletsControl?.value === 'number') ? walletsControl?.value !== 0 : false ;
    
    return isWalletsPopulated && isAtLeastOneFieldTrue ? null : { invalidForm: true };
  }

  phoenixIdValidator(phoenixIdControl: AbstractControl): ValidationErrors | null {
    //const phoenixIdControl = group.get('phoenixId');
    if (phoenixIdControl)
    {
      const hexFormatRegex = /^[A-Fa-f0-9]{8}[A-Fa-f0-9]{4}[A-Fa-f0-9]{4}[A-Fa-f0-9]{4}[A-Fa-f0-9]{12}$/;
      const valid = hexFormatRegex.test(phoenixIdControl.value);
      return valid ? null : { invalidForm : true };
    }
    return { invalidForm : true };
  }



}
